module.exports = __webpack_public_path__ + "img/paper.cfa07dac.png";